function initReadingProgressIndicator() {
  const indicator = document.querySelector('.reading-progress-indicator');
  if (!indicator) return;

  const barFill = indicator.querySelector('.reading-progress-indicator__bar-fill');
  if (!barFill) return;

  const heroBanner = document.querySelector('.page-hero-banner');
  const siteHeader = document.querySelector('.site-header');

  function getVisibleHeaderHeight() {
    if (!siteHeader) return 0;

    const headerHeight = siteHeader.offsetHeight;
    const stickyOffset = getComputedStyle(siteHeader).getPropertyValue('--sticky-header-offset');
    const stickyOffsetValue = stickyOffset ? Math.abs(parseFloat(stickyOffset)) || 0 : 0;
    const visibleHeight = headerHeight - stickyOffsetValue;

    const drupalOffset = getComputedStyle(document.documentElement).getPropertyValue('--drupal-displace-offset-top');
    const drupalOffsetValue = drupalOffset ? parseFloat(drupalOffset) || 0 : 0;

    return visibleHeight + drupalOffsetValue;
  }

  function updatePosition() {
    const height = getVisibleHeaderHeight();
    indicator.style.setProperty('--reading-progress-top', height + 'px');

    // Fallback negative margin only if height is properly calculated (e.g. not display: none)
    const offsetHeight = indicator.offsetHeight;
    if (offsetHeight > 0) {
      indicator.style.setProperty('--reading-progress-negative-height', '-' + offsetHeight + 'px');
    }
  }

  function getHeroThreshold() {
    if (heroBanner) {
      return heroBanner.offsetTop + heroBanner.offsetHeight * 0.5;
    }
    return 200;
  }

  function onScroll() {
    updatePosition();

    const scrollY = window.scrollY;
    const threshold = getHeroThreshold();

    if (scrollY > threshold) {
      indicator.classList.add('is-visible');
    } else {
      indicator.classList.remove('is-visible');
    }

    const docHeight = document.documentElement.scrollHeight;
    const winHeight = window.innerHeight;
    const maxScroll = docHeight - winHeight;
    const progress = maxScroll > 0 ? Math.min((scrollY / maxScroll) * 100, 100) : 0;
    barFill.style.width = progress + '%';
  }

  updatePosition();
  onScroll();

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener(
    'resize',
    () => {
      requestAnimationFrame(() => {
        updatePosition();
        onScroll();
      });
    },
    { passive: true },
  );

  // Recalculate when Drupal toolbar changes the viewport offset
  document.addEventListener('drupalViewportOffsetChange', () => {
    requestAnimationFrame(() => {
      updatePosition();
      onScroll();
    });
  });
}

window.addEventListener('DOMContentLoaded', () => {
  initReadingProgressIndicator();
});
